<template>
    <div class="purse">
        <public1></public1>
        <div class="purse-content right-content">
            <div class="perheader">
                <perheader></perheader>
            </div>
            <div class="table-content">
                <div class="recharge">
                    <div class="balance-info">
                        <div>
                            <span style="margin-right:0.1rem">账户余额:</span>
                            <span>{{waitmoney}}元</span>
                        </div>
                        <div class="money-button">
                            <el-button type="success" size="small" disabled>提现</el-button>
                            <el-button type="primary" size="small" @click="toRechargeTable">明细</el-button>
                        </div>
                    </div>
                    <div class="recharge-info">
                        <div>
                            <div class="recharge-content" v-for="rechargeData in rechargeDatas">
                                <div style="width:15%">{{rechargeData.OperateTime.substring(0, 10)}}</div>
                                <!--<div style="width:44%">{{rechargeData.Addr}}</div>-->
                                <div style="width:30%">{{rechargeData.RoomName}}</div>
                                <div style="width:12%">{{rechargeData.TenantName}}</div>
                                <div style="width:18%">{{rechargeData.TenantPhone}}</div>
                                <div style="width:8%">充值</div>
                                <div style="width:8%">￥{{rechargeData.Money.toFixed(2)}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="Withdraw">
                    <div class="a-title">
                        <span>提现记录</span>
                        <el-button type="primary" icon="el-icon-document" circle @click="toWithdrawTable"></el-button>
                    </div>
                    <div class="withdraw">
                        <div>
                            <div class="withdraw-content" v-for="withdrawData in withdrawDatas">
                                <div>{{withdrawData.Addtime.substring(0, 10)}}</div>
                                <div>提现</div>
                                <div style="width:0.7rem">
                                    <div>￥{{withdrawData.Money.toFixed(2)}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="Accountinfo">
                    <div class="a-title">
                        <span>提现账户</span>
                        <el-button type="primary" icon="el-icon-edit" circle disabled></el-button>
                    </div>
                    <div class="accountinfo">
                        <div class="account-content">
                            <el-tooltip class="item" effect="dark" :content="Accountname" placement="left">
                                <div>户名：{{accountinfo.Accountname}}</div>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" :content="Accountid" placement="left">
                                <div>卡号：{{Accountid}}</div>
                            </el-tooltip>
                            <div>银行：{{accountinfo.Accountbank}}</div>
                            <div>网点：{{accountinfo.Accountbranch}}</div>
                            <div>城市：{{accountinfo.Accountcity}}</div>
                            <div>手机：{{accountinfo.Phone}}</div>
                            <div v-if="accountinfo.Status==3">身份验证：完成</div>
                            <div v-else-if="accountinfo.Status==4">身份验证：被拒绝</div>
                            <div v-else>身份验证：审核中</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import public1 from '@/views/public1.vue'
    import perheader from '@/components/perheader.vue'
    import store from "../store";

    export default {
        name: "purse",
        components: {
            public1,
            perheader,
        },
        data() {
            return {
                balancemoney: {},
                waitmoney: '',
                rechargeDatas: [],
                withdrawDatas: [],
                accountinfo: [],
                Accountid: "",
                Accountname: '',
            }
        },
        mounted: function () {
            this.balance();
            this.recharge();
            this.withdraw();
            this.account();
        },
        methods: {
            balance() {
                this.$http.get(`${store.state.url}zone/cash?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        if (res.Code == 0) {
                            this.balancemoney = res.Data;
                            this.waitmoney = res.Data.waitmoney.toFixed(2)
                            // this.waitmoney = res.Data.toFixed(2)
                        } else {
                            this.$message(res.Message);
                        }
                    })
            },
            recharge() {
                this.$http.get(`${store.state.url}zone/order/${window.localStorage.userid}/0/9/0/0?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        if (res.Code == 0) {
                            this.rechargeDatas = res.Data;
                        } else {
                            this.$message(res.Message);
                        }
                    })
            },
            withdraw() {
                this.$http.get(`${store.state.url}account?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        if (res.Code == 0) {
                            let data = res.Data.slice(0, 9);
                            this.withdrawDatas = data
                        } else {
                            this.$message(res.Message);
                        }
                    })
            },
            account() {
                this.$http.get(`${store.state.url}client/user?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        if (res.Code == 0) {
                            this.accountinfo = res.Data;
                            this.Accountname = res.Data.Accountname;
                            this.Accountid = res.Data.Accountid.replace(/\s/g, '').replace(/(\d{4})(?=\d)/g, "$1 ");
                        } else {
                            this.$message(res.Message);
                        }
                    })
            },

            toRechargeTable() {
                this.$router.push('/finance');
                store.commit('assignFinanceTableTabIndex', "1");
            },

            toWithdrawTable() {
                this.$router.push('/finance');
                store.commit('assignFinanceTableTabIndex', "2");
            },


        },

    }
</script>

<style scoped>
    .purse {
        height: 100%;
    }

    .purse-content {
        margin: 4vh 3vw;
        height: 100%;
    }

    .perheader {

    }

    .table-content {
        width: 90%;
        height: 60%;
        border: 1px solid #cecece;
        margin-top: 5vh;
        margin-left: 2%;
        display: flex;
        font-size: 1.4vw;
    }

    .recharge {
        width: 60%;
        height: 100%;
        border-right: 1px solid #cecece;
    }

    .recharge .balance-info {
        border-bottom: 1px solid #cecece;
        height: 70px;
    }

    .balance-info {
        padding: 0.2rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    /*.money-button {*/
    /*display: flex;*/
    /*align-items: center;*/
    /*margin: 0.05vh auto;*/
    /*}*/

    /*.money-button .el-button {*/
    /*margin-left: 0.5rem;*/
    /*}*/

    .recharge-info {
        padding: 0.15rem;
        /*overflow-y:scroll;*/

    }

    .recharge-content {
        padding: 0.1rem 0;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .Withdraw {
        border-right: 1px solid #cecece;
        width: 22%;
        height: 100%;
    }

    .Accountinfo {
        width: 18%;

    }

    .withdraw, .accountinfo {
        padding: 0.15rem;
    }

    .a-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #cecece;
        height: 70px;
        padding: 0.15rem;
    }

    .withdraw-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding: 0.1rem 0 0.1rem 0;
    }

    .account-content div {
        font-size: 14px;
        padding: 0.1rem 0 0.1rem 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap
    }

    @media screen and (max-width: 1400px) {
        .recharge-content, .withdraw-content, .account-content div {
            font-size: 10px;
            padding:6px 0;
        }
    }


</style>
